import { List, Space } from 'antd'
import defaultStyled from 'styled-components'

const styled = defaultStyled

export const PageContainer = styled.div`
  display: flex;
  height: calc(100vh - 140px);
  gap: 16px;
`

export const Sidebar = styled.div`
  width: 380px;
  min-width: 380px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const MapContainer = styled.div`
  flex: 1;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  background: #f5f5f5;
  position: relative;
`

export const ZoneListItem = styled(List.Item)<{ $isActive?: boolean; $color?: string }>`
  cursor: pointer;
  border-left: 4px solid
    ${props => (props.$color && props.$color !== 'null' ? props.$color : 'transparent')} !important;
  transition: all 0.2s ease;
  gap: 10px;

  &:hover {
    background: #f0f5ff !important;
  }
`

export const ZoneHeader = styled.div`
  display: flex;
  align-items: start;
  flex-direction: column;
`

export const ZoneName = styled.span`
  font-weight: 500;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const ZoneMeta = styled.div`
  font-size: 12px;
  color: #8c8c8c;
  margin-top: 4px;
`

export const ActionButtons = styled(Space)`
  margin-left: auto;
`

export const Toolbar = styled.div`
  display: flex;
  gap: 8px;
  padding: 12px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
`

export const SearchWrapper = styled.div`
  padding: 0 4px;
`

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: #8c8c8c;
  text-align: center;
  padding: 24px;
`

export const MapLoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.9);
  z-index: 10;
`

export const DrawingHint = styled.div`
  position: absolute;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(24, 144, 255, 0.95);
  color: white;
  padding: 12px 24px;
  border-radius: 24px;
  font-weight: 500;
  z-index: 100;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  gap: 8px;
`

export const EditingHint = styled.div`
  position: absolute;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(250, 140, 22, 0.95);
  color: white;
  padding: 12px 24px;
  border-radius: 24px;
  font-weight: 500;
  z-index: 100;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  gap: 8px;
`
